const translations = {
    latitude: 'Latitude',
    longitude: 'Longitude'
};

export default translations;
